import { useState } from "react";
import "./Member.css";

export default function MembershipCategory() {
  const [category, setCategory] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!category) {
      alert("Please select a membership category.");
      return;
    }
    console.log("Selected Category:", category);
    alert(`You selected: ${category}`);
  };

  return (
    <div className="page-container">
      <a href="/" className="back-link">← Back Homepage</a>

      <div className="category-card">
        <h2 className="title">Select Membership Category</h2>

        <form onSubmit={handleSubmit}>
          <label>
            Membership Category<span className="required">*</span>
          </label>
          <select
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            required
          >
            <option value="">select membership category</option>
            <option value="Volunteer">Volunteer</option>
            <option value="Mobilizer">Mobilizer</option>
            <option value="Follower">Follower</option>
          </select>

          <button type="submit" className="submit-btn">
            Submit
          </button>
        </form>
      </div>
    </div>
  );
}
